import React, { useCallback, useEffect } from 'react'
// import _ from 'lodash'
import { ContainerField, RadioField } from '@sencha/ext-modern'

import { genFullListName, getMixedProps } from './blockPublic'
import { useEventHandler, useInstData } from 'tyan/public/hooks'

// const handlerRadioChange = (name, selectedValue, onChange) => () => {
// 	onChange({ name, newValue: selectedValue, type: 'string' })
// }

const Radio = ({ field, onChange: _onChange, initValues, /* changedValues, */ defaultStyle, that, that: { state: { _validStamp } } }) => {
	const { props: { required: requiredProps, ...props } } = getMixedProps('_radio', [defaultStyle, field])
	let { items, name, list, optionName, value: fieldValue, disabled } = field
	const required = requiredProps && !disabled

	const { me, me: { edited = false } } = useInstData()

	const fullName = genFullListName(list, name)
	const optionsParas = { ...that.props.optionsParas, ...that.state.optionsParas }
	items = items || optionsParas[optionName || name] || []
	const initValue = initValues && initValues[fullName] || ''
	items = items.map(item => Array.isArray(item) ? item : [item, item])
	const itemsAdd = []
	initValue && !items.find(([label, value]) => value == initValue) && itemsAdd.push([initValue, initValue, { 'text-decoration': 'line-through' }])
	const { props: { itemMinWidth, itemNoLocale, itemMargin, ...itemProps } } = getMixedProps('_radioItem', [defaultStyle, field])

	const onChange = (...args) => {
		me.edited = true
		return _onChange(...args)
	}

	return <ContainerField {...props} required={required}
		errorMessage={required && (_validStamp || edited) && !fieldValue ? '这是一个必填项' : ''}
		errorTarget='side'
	>
		{items.concat(itemsAdd).map(([label, value, style, tooltip], index) => (
			<RadioBox {...itemProps}
				{...{
					name: fullName, boxLabel: label, key: `${value}${index}`, value, tooltip,
					margin: itemMargin, noLocale: itemNoLocale, minWidth: itemMinWidth, checked: fieldValue == value, style,
					required, fieldValue, fieldName: name, onChange
				}}
			/>
		))}
	</ContainerField>
}

const RadioBox = props => {
	const { fieldName, fieldValue, onChange, required, ...boxProps } = props
	const { me } = useInstData(props)

	useEffect(() => {
		const handleSelect = e => {
			const { fieldName, fieldValue, onChange, required, value, disabled } = me.props
			// e.preventDefault()

			if (disabled) {
				e.preventDefault()
				return
			}

			true && (value != fieldValue || !required) && setTimeout(() => onChange({ name: fieldName, newValue: value != fieldValue ? value : null, type: 'string' }))
			// handlerRadioChange(fieldName, required || value != fieldValue ? value : undefined, onChange)()
			// onChange({ name, newValue: selectedValue, type: 'string' })
		}

		const listeners = {
			click: { element: 'bodyElement', fn: handleSelect },
		}

		me.radio.on(listeners)

		return () => {
			me.radio.un(listeners)
		}
	}, [])

	const ref = useCallback(ref => ref && (/* window.radio =  */me.radio = ref.cmp), [])

	return <RadioField {...boxProps} ref={ref}
	// onCheck={handlerRadioChange(fieldName, required || value != fieldValue ? value : undefined, onChange)}
	/>
}

const renderRadio = config => {
	const { key } = config.field || {}
	return <Radio key={key} {...config} />
}

export default renderRadio